import baseAPI from '@/http'

const router = 'api/acompanhamento/diagnostico'

export const diagnosticAPI = {
  createDiagnostic: (attendance) => baseAPI.post(router + '/save-diagnostico', attendance),
  update: (diagnostic) => baseAPI.put(router, diagnostic),
  get: (id) => baseAPI.get(`${router}/${id}`),
  getQuestion: (themeId, attendanceId, nacional) => baseAPI.get(`${router}/get-pergunta?temaId=${themeId}&municipioId=${attendanceId}&nacional=${nacional}`),
  finish: (id) => baseAPI.post(`${router}/finalizar-diagnostico/${id}`, {}),
  finishTheme: (id) => baseAPI.post(`${router}/finalizar-tema-diagnostico/${id}`, {}),
  returnQuestion: (question) => baseAPI.post(router + '/voltar-pergunta', question)
}
